import React from 'react'
import getUrl from 'libraries/front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import cx from 'classnames'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import ListItemContainer from 'redux/containers/pages/legislationcategories/ListItemContainer'

const SectionHeader = ({ aols, title, toggle, expanded, sectionId }) => toggle
  ? (
    <a
      href={null}
      className={cx(
        'h3 pv5 pl6 pr6 ma0 bb db flex items-center justify-between hover-gains-boro',
        'bg-suez-canal white f5 fw6 pointer hover-no-underline font-reset-fix'
      )}
      onClick={toggle}
      data-event-action={expanded ? 'Collapse' : 'Expand'}
      data-event-category='Legislation Folders'
      data-event-label={`${sectionId}: ${title}`}
      data-event-aol={`[${aols.toString()}]`}
    >
      <span>
        {title}
      </span>
      <span className='white pr2'>
        {expanded ? <KeyboardArrowUp className='w8 h-auto vm' /> : <KeyboardArrowDown className='w8 h-auto vm' />}
      </span>
    </a>
    )
  : (
    <div>
      {title}
    </div>
    )

const List = ({ aols, childrenList, expanded, toggleExpandedSection, sectionId, name, count }) => {
  if (!expanded && toggleExpandedSection) {
    return null
  }

  if (count.length === 0) {
    return (
      <ul className='list-reset pa0'>
        <li>
          <div className='h3 bb b--black fw6 f5 pl6 flex flex-column justify-center items-start ma0'>No legislation to show</div>
        </li>
      </ul>
    )
  }

  return (
    <ul className='list-reset pa0'>
      {childrenList.map(legislation => (
        <ListItemContainer key={legislation.id} {...{ aols, legislation, sectionId, name }} />
      ))}
    </ul>
  )
}

const Heading = ({ id, name, children, expanded, toggleExpandedSection, sectionId }) => {
  const aols = children.reduce((acc, curr) => {
    const areas = (curr.areasOfLaw || []).filter(aol => acc.includes(aol) === false)
    return [...acc, ...areas]
  }, [])

  // No category name (e.g. Court Guides) - show the legislation flat, with no section header to expand/collapse
  const collapsible = Boolean(name)

  return (
    <li id={getUrl(LEGISLATION, { path: id })} className='w-100'>
      {collapsible && (
        <SectionHeader
          toggle={toggleExpandedSection && (() => toggleExpandedSection(id))}
          title={name}
          expanded={expanded}
          sectionId={sectionId}
          aols={aols}
        />
      )}
      <List
        {...{
          aols,
          childrenList: children,
          count: children.filter(c => c.hidden === false).length,
          expanded: collapsible ? expanded : true,
          toggleExpandedSection: collapsible ? toggleExpandedSection : null,
          sectionId,
          name
        }}
      />
    </li>
  )
}

export default Heading
